module.exports = __webpack_public_path__ + "img/call-user--default-avator.95fa46b0.svg";